module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_8-b57a1be2faf506094592cc3cee8e745d.jpg";